export const GCIS_PAYMENT_HANDLER = 'GCIS_PAYMENT';
